// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"17246a89","213":"9ab4a53f"}[chunkId] + ".chunk.js";
};